import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LocalizedSchemaService } from '../../../services/localized-schema.service';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './faq.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './faq.component.scss'
})
export class FAQComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private schema: LocalizedSchemaService
  ) { }

  ngOnInit(): void {
    const currentPath = this.router.url;
    if (currentPath === '/albcode/faq' && !this.document.getElementById('faq-schema')) {
      const script = this.document.createElement('script');
      script.id = 'faq-schema';
      script.type = 'application/ld+json';
      script.text = this.schema.serialize({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": $localize`Was macht AlbCode genau?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`AlbCode entwickelt individuelle Softwarelösungen für Unternehmen – von Webportalen über mobile Apps bis hin zu komplexen Backend-Systemen und Anbindung verschiedener Schnittstellen. Wir unterstützen Sie bei der Digitalisierung Ihrer Geschäftsprozesse, sowie Ihrer Online-Präsenz.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Welche Technologien verwendet AlbCode?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`Wir arbeiten mit modernen Technologien wie Java, Spring Boot, Angular, TypeScript, PostgreSQL und Docker. So entstehen stabile, skalierbare und zukunftssichere Anwendungen.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Für welche Branchen entwickelt AlbCode Software?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`Wir entwickeln branchenunabhängig – ob Handwerk, Industrie, Dienstleistung oder Verwaltung. Unser Fokus liegt auf passgenauer Software, nicht auf Standardlösungen.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Wie läuft ein Projekt mit AlbCode ab?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`Wir starten mit einer Analyse Ihres Bedarfs, erstellen ein technisches Konzept und setzen die Software agil in enger Abstimmung mit Ihnen um – inklusive Hosting und Wartung, falls gewünscht.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Wo ist AlbCode ansässig und für wen arbeitet AlbCode?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`AlbCode hat seine Wurzeln in Hechingen auf der Schwäbischen Alb. Regional sind wir gerne persönlich für unsere Kunden da – deutschlandweit und international arbeiten wir flexibel und remote. Egal ob um die Ecke oder über Kontinente hinweg: Wir bringen Projekte zuverlässig zum Ziel.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Wie kann ich AlbCode kontaktieren?`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`Sie erreichen uns per E-Mail an m.saliger@albcode.de oder über unsere Webseite.`
            }
          },
          {
            "@type": "Question",
            "name": $localize`Was kostet mich ein Projekt mit AlbCode? Warum individuelle Software günstiger ist, als viele denken.`,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": $localize`Die Kosten für ein Projekt mit AlbCode hängen von verschiedenen Faktoren ab – etwa vom Umfang, der Komplexität und den gewünschten Funktionen. Aber keine Sorge: Sie behalten jederzeit den Überblick. Wir legen großen Wert auf Kostentransparenz und stimmen jeden Schritt mit Ihnen ab. Individuell entwickelte Software ist langfristig kosteneffizienter und passgenauer als Standardlösungen oder cloud-basierte Software-as-a-Service-Produkte (SaaS), bei denen sie regelmäßig Lizenzgebühren zahlen müssen. Bei AlbCode erhalten Sie eine maßgeschneiderte langlebige Lösung, die genau auf Ihre Bedürfnisse zugeschnitten ist.`
            }
          }
        ]
      });
      this.document.head.appendChild(script);
    }
  }
}
